const CircleSVG = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 106.94 106.95" className="absolute slate w-1/2 z-10 opacity-30 transition-all duration-300 group-hover:w-3/4">
            <defs>
                <linearGradient id="a" x1="-16186.95" x2="-16080" y1="17680.97" y2="17680.97" gradientTransform="rotate(135 -4389.231 12219.649)" gradientUnits="userSpaceOnUse">
                <stop offset="0" stopColor="#ff77fc"/>
                <stop offset=".49" stopColor="#ff9ba8"/>
                <stop offset="1" stopColor="#ffc053"/>
                </linearGradient>
            </defs>
            <circle cx="53.47" cy="53.47" r="53.47" fill="url(#a)"/>
        </svg>
    )
}
export default CircleSVG;